module.exports = __webpack_public_path__ + "img/Cerdas.bee0a1cf.png";